// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"EditAppModal_modalBackdrop__Evvox","modalContent":"EditAppModal_modalContent__atS2e"};